/** Created by azhou on 2019/2/15.*/
<template>
  <div class="d-center">
    <span :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="form-left-text tiole">{{leftText}}</div>：
    <div class="option-wrap">
      <el-radio-group class="group " :class="[radio ? 'radio-group':'radio-nrls']" v-model="valueInside" @change="onChange" >
        <el-radio  v-for="item in options"
          :key="item.id"
          :label="item.id"
          :value="item.id">{{item.name}}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import { Radio } from 'element-ui';
import RegDocumentsWrapVue from '../../views/Register/Comp/RegDocuments/RegDocumentsWrap.vue';
export default {
  name: "LeftTextRadio",
  props: {
    value: {},
    leftText: {
      type: String
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      valueInside: null
    };
  },
  created() {
    //当prop传入的值没有发生变化时，组件被重新创建后需要再次赋值
    if (this.value) this.valueInside = this.value;
  },
  watch: {
    value(nval) {
      if(nval||nval==0){
        this.valueInside = nval;
      }
    }
  },
  methods: {
    onChange() {
      this.$emit("input", this.valueInside);
    }
  }
};
</script>

<style scoped lang="scss">
.d-center {
  justify-content: inherit;
  align-items: flex-start;
  line-height: 13px;
}
.option-wrap {
  flex: 1;
  .group {
    display: flex;
    flex-wrap: wrap;
  }
  ::v-deep .el-radio{
    margin-bottom: 7px;
  }
}

</style>
<style>
.radio-group .el-radio__label{
  min-width: 100px !important;
  display: inline-block;
  text-align: left;
}
.radio-nrls .el-radio__label{
  min-width: 70px !important;
  display: inline-block;
  text-align: left;
}
</style>